import { Context } from '../server-middleware/context'

interface ConfigurationKeyMap {
  'ssi.header_processed_url': string
  'custom_header.html': string
  'header.label': string
  'header.labelMobile': string
  'header.url': string
  'header.logoUrl': string
  'header.linkColor': string
  'header.backgroundColor': string

  'community_header.type': string
  'community_footer.type': string
  'custom_footer.html': string
  'ssi.footer_enabled': string

  'thirdparty.ssiProcessedUrl': string
  'thirdparty.head': string
  'thirdparty.bodyStart': string
  'thirdparty.bodyEnd': string

  'branding.custom_css': string

  'basicAppearance.favicon': string
  'basicAppearance.homepageMetaTitle': string
  'basicAppearance.homepageMetaDescription': string

  'branding.css_variables': {
    [key: string]: string|null
  }

  'salesforceFederatedSearchEnabled': boolean
}

async function getAllConfig (context: Context) {
  return await context.cache('config_community', async () => {
    const row = await context.prismaClient.config_community.findMany({
      where: {
        value: {
          not: null
        }
      }
    })
    const c = row.reduce<Record<string, string|null>>((acc, cur) => {
      acc[cur.key] = cur.value
      return acc
    }, {})
    return c
  })
}

export default async function getConfigWithPrisma<T extends keyof ConfigurationKeyMap> (context: Context, k: T): Promise<ConfigurationKeyMap[T]> {
  const config = await getAllConfig(context)
  return JSON.parse(config[k] || 'null')
}
